// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TextHomepage_Wrapper__6uxGN","Header":"TextHomepage_Header__mBbJc","step":"TextHomepage_step__by6AT","TopTitle":"TextHomepage_TopTitle__Q38qj"};